import { render } from "./Fields.vue?vue&type=template&id=9531f56a"
import script from "./Fields.vue?vue&type=script&setup=true&lang=js"
export * from "./Fields.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/forge/retail.digitalhq.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/admin/ui/Components/Common/Filters/Fields.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9531f56a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9531f56a', __exports__)) {
    api.reload('9531f56a', __exports__)
  }
  
  module.hot.accept("./Fields.vue?vue&type=template&id=9531f56a", () => {
    api.rerender('9531f56a', render)
  })

}


export default __exports__